import { Component, OnInit, Input } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-detail-cda',
  templateUrl: './detail-cda.component.html',
  styleUrls: ['./detail-cda.component.scss']
})
export class DetailCdaComponent implements OnInit {
  @Input() categoryType: string;
  @Input() categories: any;

  val: any;
  constructor() { }

   ngOnInit() {
      const that = this;
      $(document).ready(function() {
        $('#myInput').on('keyup', function() {
          var value = $(this).val().toString().toLowerCase();
            $('.cdaSearch').filter(function() {
              $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                return true;
            });
        });
      });
      $(document).ready(function(categoryType) {
        $('#myInput_i'+that.categoryType).on('keyup', function() {
          var value = $(this).val().toString().toLowerCase();
            $('.cdaSearch_i'+that.categoryType).filter(function() {
              $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                return true;
            });
        });
      });
   }
}
